export default "__VITE_ASSET__DkxrCoeC__"